import { generateHealthSegments } from './healthSegmentsAggregator';

export const getAnswerAggregationStrategy = (assessmentType)=>{
    const strategies = {
        dependentOnRoot,
        independent,
        independentPointsBased
    };

    if(! strategies[assessmentType]){
        return independent;
    }

    return strategies[assessmentType];
};

const dependentOnRoot = (assessment, inAssessmentFilters, allPrompts) => {
    const promptIds = Object.keys(inAssessmentFilters);

    let aggregated = [];

    promptIds.forEach(promptId => {
        if (!isRootPrompt(assessment, promptId)) {
            const validfilters = removeNoneFilter(inAssessmentFilters[promptId]);
            aggregated.push(...validfilters);
        }
    });

    //TODO: filter out those that were not selected in initial prompt

    return aggregated;
}

const independent = (assessment, inAssessmentFilters, allPrompts) => {
    const promptIds = Object.keys(inAssessmentFilters);

    let aggregated = [];

    promptIds.forEach(promptId => {
        const validfilters = removeNoneFilter(inAssessmentFilters[promptId]);
        aggregated.push(...validfilters);
    });

    return aggregated;
}

const independentPointsBased = (assessment, inAssessmentFilters, allPrompts) => {
    const promptIds = Object.keys(inAssessmentFilters);

    let aggregated = [];

    promptIds.forEach(promptId => {
        const prompt = allPrompts[promptId];
        const {
            maxSelection,
            containsNoneOption
        } = prompt;
        const filterQueue = inAssessmentFilters[promptId];

        let points = [];

        if (maxSelection) {
            points = filterQueue.filter(element => element !== null); //Only aggregate non-zero values if there is a max selection cap
        } else {
            for (let element of filterQueue) {
                element = (element) ? element : 0;
                points.push(element);
            }
        }

        if (containsNoneOption) {
            points.pop(); //Remove the last element (None option should not hold position in aggregated array)
        }

        aggregated.push(...points);
    });

    console.log("Aggregated answer options: ", aggregated);

    //@TODO: move into own strategy once there are more points-based quizzes
    const mappedAggregate = generateHealthSegments(aggregated);

    return mappedAggregate;
}


const removeNoneFilter = (filters) => {
    return filters.filter(filter => filter && !isNoneFilter(filter));
}

const isNoneFilter = (filter) => {
    return filter.includes('None of these') || filter === -1;
}

const isRootPrompt = (assessment, promptId) => {
    return promptId === assessment.rootPrompt;
}